import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        $('body').css('overflow', 'auto !important'); // recalculate scroll after turbo update
    }
}